import { EGamePeriod } from '@/app/pages/sports/football/enums';
import {
  EIncidentKind,
  ETeamGround,
  MatchIncident,
  MatchIncidentPlayer,
  MatchIncidents,
} from '../models';

export function adaptIncidents(flatIncidents: any[]): MatchIncidents {
  if (!flatIncidents.length) {
    return {
      Id: '',
      TsExternalId: '',
      FirstHalfIncidents: [],
      SecondHalfIncidents: [],
      OvertimeIncidents: [],
      PenaltyShootOutIncidents: [],
    };
  }

  const id = flatIncidents[0].idMatchIncident ?? '';

  const mapIncident = (incident: any): MatchIncident => {
    return {
      AssistPlayer: mapPlayer(incident.assistPlayer),
      AwayScore: incident.awayScore ?? 0,
      GameTime: incident.gameTime ?? 0,
      HomeScore: incident.homeScore ?? 0,
      Kind: incident.kind ?? EIncidentKind.GOAL,
      Player: mapPlayer(incident.player),
      ReasonType: '',
      SubstitutePlayer: mapPlayer(incident.substitutePlayer),
      TeamGround: incident.teamGround ?? ETeamGround.HOME,
      VarReason: incident.varReason ?? null,
      VarResult: incident.varResult ?? null,
    };
  };

  return {
    Id: id,
    TsExternalId: id,
    FirstHalfIncidents: flatIncidents
      .filter((i) => i.gamePeriod === EGamePeriod.FIRST_HALF)
      .map(mapIncident),
    SecondHalfIncidents: flatIncidents
      .filter((i) => i.gamePeriod === EGamePeriod.SECOND_HALF)
      .map(mapIncident),
    OvertimeIncidents: flatIncidents
      .filter((i) => i.gamePeriod === EGamePeriod.OVERTIME)
      .map(mapIncident),
    PenaltyShootOutIncidents: flatIncidents
      .filter((i) => i.gamePeriod === EGamePeriod.PENALTY_SHOOT_OUT)
      .map(mapIncident),
  };
}

function incidentPeriod(incident: any): EGamePeriod | undefined {
  return incident?.gamePeriod ?? null;
}

function mapPlayer(player: any): MatchIncidentPlayer | undefined {
  if (!player) return undefined;
  return {
    Id: player.id ?? '',
    Name: player.name ?? '',
    NameTranslation: player.nameTranslation ?? null,
    ShortName: player.shortName ?? '',
    ShortNameTranslation: player.shortNameTranslation ?? null,
    TsExternalId: player.tsExternalId ?? '',
  };
}
